import { useEffect, useRef } from "react";
import { store } from "../Redux/store";
import { getSessionTimeoutMinutes } from "../Redux/reducer/SessionTimeoutReducer";

const DEFAULT_TIMEOUT_MINUTES = 30;

const ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];

export default function useSessionTimeout() {
  const lastActivityAtRef = useRef(null);

  useEffect(() => {
    const logout = () => {
      localStorage.removeItem("loginTime");
      localStorage.removeItem("persist:root");
      window.location.href = "/";
    };

    const updateLastActivity = () => {
      lastActivityAtRef.current = Date.now();
    };

    const checkSession = () => {
      const loginTime = localStorage.getItem("loginTime");
      if (!loginTime) {
        localStorage.setItem("loginTime", Date.now().toString());
        return;
      }
      const token = store?.getState()?.LOGIN_CREDS?.user?.token;
      if (!token) return;

      const timeoutMinutes = getSessionTimeoutMinutes(store.getState()) ?? DEFAULT_TIMEOUT_MINUTES;
      const inactivityTimeoutMs = timeoutMinutes * 60 * 1000;
      const currentTime = Date.now();

      if (lastActivityAtRef.current === null) {
        lastActivityAtRef.current = currentTime;
      }
      // Logout only when last activity exceeds the limit from DB (inactivity timeout)
      if (currentTime - lastActivityAtRef.current > inactivityTimeoutMs) {
        logout();
      }
    };

    checkSession();
    const interval = setInterval(checkSession, 1000);

    // Track user activity so we can log out after inactivity
    ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, updateLastActivity);
    });

    return () => {
      clearInterval(interval);
      ACTIVITY_EVENTS.forEach((event) => {
        window.removeEventListener(event, updateLastActivity);
      });
    };
  }, []);
}
